import type { ProviderLogo } from '~/content/types';
import { ScrollStrip } from './ScrollStrip';

/**
 * Horizontal strip of exchange/provider logos (Figma Stablecoin hero band) — an
 * instance of the shared {@link ScrollStrip} in the default `scroll` layout so it
 * matches the stats strip: fixed-width logo + name items with a 40px inner left
 * padding and vertical dividers, in a drag-scrollable / cropped track.
 */
export function ProvidersStrip({
  providers,
  className,
}: {
  providers: ProviderLogo[];
  className?: string;
}) {
  return (
    <ScrollStrip
      items={providers}
      getKey={(provider) => provider.name}
      // Mobile: 15px text, 24px logo, padding trimmed 4px (py-6→py-5, pl-10→pl-9);
      // desktop values preserved via md:. Auto-scrolls as a gentle marquee on
      // mobile only (static, drag-scrollable on desktop).
      autoScrollMobileOnly
      itemClassName="w-[256px] gap-5 py-5 pl-9 md:py-6 md:pl-10"
      className={className}
      renderItem={(provider) => (
        <>
          <img
            src={provider.src}
            alt={provider.name}
            className="size-6 shrink-0 object-contain md:size-7"
          />
          <span className="text-[15px] font-medium text-ink md:text-body">{provider.name}</span>
        </>
      )}
    />
  );
}
